import React from "react";
import Header from "../../../shared/layout/Header";
import ColorInit from "../../../shared/layout/ColorInit";
import { CartProvider } from "../../cart/context/CartContext";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import AboutUs from "../components/AboutUs";
import ScrollToTop from "react-scroll-to-top";

const AboutUsPage = () => {
    return (
        <CartProvider>
        <ScrollToTop smooth color="#ef253c" />
        {/* <Preloader /> */}
        {/* <ColorInit color={'bigmall'} /> */}
        <ColorInit color={'bigmall'} />
        <Header />
        <div className="container container-lg">
        <AboutUs />
        </div>
        <Footer />
        <BottomFooter />
        </CartProvider>
    );
    }
export default AboutUsPage;